<template>
    <transition name="fade">
        <div v-if="open" class="flex">
            <slot></slot>

            <div class="text-xl" @click.prevent="close">
                <i class="fas fa-times-circle cursor-pointer mt-px text-gray-300 hover:text-gray-400"></i>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        data() {
            return {
                open: true,
            };
        },

        methods: {
            close() {
                this.open = false;

                this.$parent.$forceUpdate();
            },
        },
    };
</script>
